export interface StoredImage {
  url: string
  name: string
}

function readFile(file: File): Promise<StoredImage> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve({ url: String(reader.result), name: file.name })
    reader.onerror = () => reject(new Error(`Kunne ikke læse ${file.name}`))
    reader.readAsDataURL(file)
  })
}

/**
 * Læser billeder som data-URL'er, så de kan gemmes og stadig vises efter en genindlæsning.
 * (Object-URL'er forsvinder, når siden lukkes.)
 */
export async function readImages(files: FileList | File[] | null): Promise<StoredImage[]> {
  if (!files) return []
  const list = Array.from(files).filter((file) => file.type.startsWith('image/'))
  return Promise.all(list.map(readFile))
}
